<template>
    <div class="row">
        <div class="col-md-4 mb-1">
            <label class="form-label">Lokasyon Tipi</label>
            <v-select-list v-model="locationType" placeholder="Lokasyon Tipi" label="Name" :options="locationTypes"/>   
        </div>
        <div class="col-md-4 mb-1">
            <label class="form-label">Lokasyon İsmi</label>
            <input type="text" v-model="value.LocationName" placeholder="Lokasyon İsmi" class="form-control"/>
        </div>
        <div class="col-md-4 mb-1">
            <label class="form-label">Ülke</label>
            <v-select-list v-model="country" placeholder="Ülke" v-on:input="getProvince(true)" label="Name" :options="countries"/>   
        </div>
        <div class="col-md-4 mb-1">
            <label class="form-label">Şehir/İl</label>
            <v-select-list v-model="province" placeholder="Şehir/İl" v-on:input="getDistricts(true)" label="Name" :options="provinces"/>   
        </div>
        <div class="col-md-4 mb-1">
            <label class="form-label">İlçe</label>
            <v-select-list :disabled="!province" placeholder="İlçe" v-model="district" v-on:input="getNeighborhoods(true)" label="Name" :options="districts"/>
        </div>
        <div class="col-md-4 mb-1">
            <label class="form-label">Mahalle</label>
            <v-select-list :disabled="!district || neighborhoods.length == 0" v-model="neighborhood" v-on:input="getStreets" placeholder="Mahalle" label="Name" :options="neighborhoods"/>   
        </div>
        <div class="col-md-4 mb-1">
            <label class="form-label">Sokak</label>
            <v-select-list :disabled="!neighborhood || streets.length == 0" v-model="street" placeholder="Sokak" label="Name" :options="streets"/>   
        </div>
        <div class="col-md-4 mb-1">
            <label class="form-label">Posta Kodu</label>
            <input type="text" v-model="value.PostalCode" placeholder="Posta Kodu" class="form-control"/>
        </div>
        <div class="col-md-4 mb-1">
            <label class="form-label">Bina Numarası</label>
            <input type="text" v-model="value.BuildingNumber" placeholder="Bina Numarası" class="form-control"/>
        </div>
        <div class="col-md-4 mb-1">
            <label class="form-label">Kat</label>
            <input type="text" v-model="value.Floor" placeholder="Kat" class="form-control"/>
        </div>
        <div class="col-md-4 mb-1">
            <label class="form-label">Kapı Numarası</label>
            <input type="text" v-model="value.DoorNumber" placeholder="Kapı Numarası" class="form-control"/>
        </div>
        <div class="col-md-4 mb-1">
            <label class="form-label">Enlem</label>
            <input type="text" v-model="value.Xcoordinate" disabled placeholder="Enlem" class="form-control"/>
        </div>
        <div class="col-md-4 mb-1">
            <label class="form-label">Boylam</label>
            <input type="text" v-model="value.Ycoordinate" disabled placeholder="Boylam" class="form-control"/>
        </div>
        <div class="col-12 mb-75">
            <b-form-checkbox v-model="value.IsInvoiceAddress">Fatura Lokasyonu</b-form-checkbox>
        </div>
        <div class="col-12 mb-1" v-if="value.IsInvoiceAddress">
            <label class="form-label">Fatura Başlığı</label>
            <input type="text" v-model="value.InvoiceTitle" placeholder="Fatura Başlığı" class="form-control"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Posta Adresi</label>
            <input type="text" v-model="value.PostalAddress" placeholder="Posta Adresi" class="form-control"/>
        </div>
        <div class="col-12">
            <div class="find-location">
                <google-maps-find-location v-on:location="onLocation" :address="addressForMap" :initialPos="initialPos"></google-maps-find-location>
            </div>
        </div>
        <div class="d-none">{{address}}</div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'
import GoogleMapsFindLocation from '@/components/GoogleMapsFindLocation.vue'
import { BFormCheckbox } from 'bootstrap-vue'

export default {
    components:{
        GoogleMapsFindLocation,
        BFormCheckbox
    },
    props:{
        value:Object,
        countries:Array,
        locationTypes:Array,
        editing:Boolean,
    },
    data(){
        return {
            provinces:[],
            districts:[],
            neighborhoods:[],
            streets:[],
        }
    },
    mounted(){
        if(this.editing){
            this.getProvince()
            this.getDistricts()
            this.getNeighborhoods()
            this.getStreets()
        }
    },
    watch:{
        country(oldV, newV){
            if(oldV !== newV){
                this.getProvince()
                this.value.Province = null
                this.value.ProvinceId = null
                this.value.District = null
                this.value.DistrictId = null
                this.value.Neighborhood = null
                this.value.NeighborhoodId = null
                this.value.Street = null
                this.value.StreetId = null
            }
        },
        // province(oldV, newV){
        //     if(oldV !== newV){
        //         this.getDistricts()
        //         this.value.District = null
        //         this.value.DistrictId = null
        //         this.value.Neighborhood = null
        //         this.value.NeighborhoodId = null
        //     }
        // },
        // district(oldV, newV){
        //     if(oldV !== newV){
        //         this.getNeighborhoods()
        //         this.value.Neighborhood = null
        //         this.value.NeighborhoodId = null
        //     }
        // },
    },
    methods:{
        // onCountryChange(){
        //     this.getProvince()
        //     this.value.Province = null
        //     this.value.ProvinceId = null
        //     this.value.District = null
        //     this.value.DistrictId = null
        //     this.value.Neighborhood = null
        //     this.value.NeighborhoodId = null
        // },
        getProvince(bool){
            if(this.value.CountryId){
                this.getDistricts()
                if(bool){
                    // onCountryChange()
                    this.value.District = null
                    this.value.DistrictId = null
                    this.value.Neighborhood = null
                    this.value.NeighborhoodId = null
                    this.value.Street = null
                    this.value.StreetId = null
                }
                SystemDataApi.ProvinceByCountry(this.value.CountryId).then(res=>{
                    this.provinces = res.data.Data
                })
            }
            this.$forceUpdate()
        },
        getDistricts(bool){
            if(this.value.ProvinceId){
                this.getNeighborhoods()
                if(bool){
                    this.value.Neighborhood = null
                    this.value.NeighborhoodId = null
                    this.value.Street = null
                    this.value.StreetId = null
                }
                SystemDataApi.District(this.value.ProvinceId)
                .then(res=>{
                    this.districts = res.data.Data
                })
            }
            this.$forceUpdate()
        },
        getNeighborhoods(bool){
            if(this.value.DistrictId){
                this.getStreets()
                if(bool){
                    this.value.Street = null
                    this.value.StreetId = null
                }
                SystemDataApi.Neighborhood(this.value.DistrictId)
                .then(res=>{
                    this.neighborhoods = res.data.Data
                })
            }
            this.$forceUpdate()
        },
        getStreets(){
            if(this.value.NeighborhoodId){
                SystemDataApi.Street(this.value.NeighborhoodId).then(res => {
                    this.streets = res.data.Data
                })
            }
            this.$forceUpdate()
        },
        onLocation(pos){
            if(pos){
                this.value.Xcoordinate = pos.lat.toFixed(4)
                this.value.Ycoordinate = pos.lng.toFixed(4)
            }
        }
    },
    computed:{
        initialPos(){
            if(this.value.Xcoordinate && this.value.Ycoordinate){
                return {lat:Number(this.value.Xcoordinate),lng:Number(this.value.Ycoordinate)}
            }else return null
        },
        addressForMap(){
            return [
                this.country?.Name || null,
                this.province?.Name || null,
                this.district?.Name || null,
                this.neighborhood?.Name || null
            ].join(',')
        },
        country:{
            get:function(){
                return this.countries.find(b=>b.Id==this.value.CountryId)
            },
            set:function(value){
                this.value.Country = value
                this.value.CountryId = value?.Id || null
            }
        },
        province:{
            get:function(){
                return this.provinces.find(b=>b.Id==this.value.ProvinceId)
            },
            set:function(value){
                this.value.Province = value
                this.value.ProvinceId = value?.Id || null
            }
        },
        district:{
            get:function(){
                return this.districts.find(s=>s.Id==this.value.DistrictId)
            },
            set:function(value){
                this.value.District = value
                this.value.DistrictId = value?.Id || null
            }
        },
        neighborhood:{
            get:function(){
                return this.neighborhoods.find(s=>s.Id==this.value.NeighborhoodId)
            },
            set:function(value){
                this.value.Neighborhood = value
                this.value.NeighborhoodId = value?.Id || null
            }
        },
        street:{
            get:function(){
                return this.streets.find(s=>s.Id==this.value.StreetId)
            },
            set:function(value){
                this.value.Street = value
                this.value.StreetId = value?.Id || null
            }
        },
        locationType:{
            get:function(){
                return this.locationTypes.find(s=>s.Id==this.value.LocationTypeId)
            },
            set:function(value){
                this.value.LocationType = value
                this.value.LocationTypeId = value?.Id || null
            }
        },
        address(){
            let neighborhood = this.value.Neighborhood?.Name || null
            let building = this.value.BuildingNumber || null
            let floor = this.value.Floor || null
            let door = this.value.DoorNumber || null
            let postal = this.value.PostalCode
            let district = this.value.District?.Name || null
            let province = this.value.Province?.Name || null
            let address = [
                neighborhood ? `${neighborhood} Mahallesi` : neighborhood,
                building ? `No:${building}` : building,
                floor ? `Kat:${floor}` : floor,
                door ? `Kapı:${door}` : door,
                postal ? `Posta Kodu:${postal}` : postal,
                [district,province].join("/")
            ].join(" ")
            this.value.Address = address
            return address
        }   
    }
}
</script>

<style>
    .location-name-placeholder{
        color: rgb(0,0,0,0.5);
    }
    .dark-layout .location-name-placeholder{
        color: rgb(255,255,255,0.5);
    }
    .find-location{
        height: 300px;
    }
</style>